/*
    Add here your own custom javascript ​​​‍​‌‍‌​‍​​‍‌‌⁠​‌‌​‍​‌‌‌‍​‌‌​‍​‌‌‌‍‌​​‌‍‌​​​‍​​‌‌‍‌​​​‍​​‌​‍​​​​‍‌​​​‍‌​​​‍​​‌​﻿‍‌​​‌‍‍‍‍‍‍
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

/* == bonusy: bocna lista kosika (The GARDEN, 2026-09-12) == */
;(function () {                                                            // úvodná ; = ochrana pred zlepením s kódom témy po minifikácii (Shopify strippe komentáre)
  var L = {"line": "Ušetríte", "total": "Bonusy zdarma v hodnote", "saved": "Dnes ušetríte spolu"}, fmt = "{{amount_with_comma_separator}}";
  function money(cents) {
    var v = cents / 100, s = fmt.indexOf('no_decimals') > -1 ? String(Math.round(v)) : v.toFixed(2);
    var parts = s.split('.'), intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.indexOf('comma_separator') > -1 ? '.' : ',');
    s = parts.length > 1 ? intp + (fmt.indexOf('comma_separator') > -1 ? ',' : '.') + parts[1] : intp;
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s);
  }
  function parseCents(text) {
    var s = (text || '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    if (fmt.indexOf('no_decimals') > -1) return parseInt(s.replace(/[.,]/g, ''), 10) * 100 || 0;
    if (fmt.indexOf('comma_separator') > -1) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, '');
    return Math.round((parseFloat(s) || 0) * 100);
  }
  function isBonus(li) {
    var h = li.getAttribute('data-product-handle') || '', t = (li.querySelector('.product-item-title') || {}).textContent || '';
    return h.indexOf('bonus-') === 0 || /^\s*BONUS:/i.test(t);
  }
  function isFree(li) {
    var fin = li.querySelector('.product-item-price-final'), cmp = li.querySelector('.product-item-price-compare s');
    return !!(fin && cmp && parseCents(fin.textContent) === 0 && parseCents(cmp.textContent) > 0);
  }
  function row(id, icon, label) {
    var p = document.createElement('p'); p.id = id; p.className = 'd-flex justify-content-between mb-2'; p.style.color = '#70A562';
    p.innerHTML = '<span>' + icon + ' ' + label + '</span><strong></strong>'; return p;
  }
  function apply() {
    var d = document.getElementById('offcanvas-cart'); if (!d) return;
    var lines = d.querySelectorAll('li[data-cart-line-item]'), sum = 0, fixes = [];
    lines.forEach(function (li) {
      if (!isFree(li)) return;
      if (!li.classList.contains('is-free')) li.classList.add('is-free');
      var p = li.querySelector('.product-item-price'), cmp = li.querySelector('.product-item-price-compare s');
      sum += parseCents(cmp.textContent);
      var want = L.line + ' ' + cmp.textContent.trim(), s = li.querySelector('.bonus-saving');
      if (!s) { s = document.createElement('small'); s.className = 'bonus-saving d-block fw-bold'; s.style.color = '#70A562'; p.appendChild(s); }
      if (s.textContent !== want) s.textContent = want;
      if (isBonus(li)) {
        if (!li.classList.contains('is-bonus')) li.classList.add('is-bonus');
        var inp = li.querySelector('.quantity-wrapper input');
        if (inp && parseInt(inp.value, 10) > 1) fixes.push(inp);
      }
    });
    var ul = lines.length ? lines[0].parentNode : null;                     // platené hore, zadarmo dole
    if (ul) {
      var arr = Array.prototype.slice.call(lines), seen = false, needs = false;
      arr.forEach(function (li) { if (li.classList.contains('is-free')) seen = true; else if (seen) needs = true; });
      if (needs) arr.filter(function (li) { return li.classList.contains('is-free'); }).forEach(function (li) { ul.appendChild(li); });
    }
    if (fixes.length && !window.__bonusQtyFixing && typeof window.onChangeCartQty === 'function') {   // BONUS vždy 1 ks, cez handler témy (prekreslí lištu)
      var sig = fixes.map(function (i) { return i.getAttribute('data-line-item-key'); }).sort().join('|'), prev = {};
      try { prev = JSON.parse(sessionStorage.getItem('bonusQtyFix') || '{}'); } catch (e) {}
      if (!(prev.sig === sig && Date.now() - (prev.at || 0) < 20000)) {
        window.__bonusQtyFixing = true;
        try { sessionStorage.setItem('bonusQtyFix', JSON.stringify({ sig: sig, at: Date.now() })); } catch (e) {}
        var inp0 = fixes[0]; inp0.value = 1;
        Promise.resolve(window.onChangeCartQty(inp0)).then(function () { window.__bonusQtyFixing = false; }, function () { window.__bonusQtyFixing = false; });
      }
    }
    var sub = document.getElementById('offcanvas-cart-subtotal'); if (!sub) return;
    var box = document.getElementById('bonus-savings-drawer');
    if (!box && sum > 0) { box = row('bonus-savings-drawer', '&#127873;', L.total); sub.parentNode.insertBefore(box, sub); }
    if (box) {
      var st = box.querySelector('strong'), t1 = money(sum);
      if (st.textContent !== t1) st.textContent = t1;
      if (box.classList.contains('d-none') !== !(sum > 0)) box.classList.toggle('d-none', !(sum > 0));
    }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var td = c.total_discount || 0, r2 = document.getElementById('bonus-total-saved-drawer'), sub2 = document.getElementById('offcanvas-cart-subtotal');
      if (!sub2) return;
      if (!r2 && td > 0) r2 = row('bonus-total-saved-drawer', '&#127991;&#65039;', L.saved);
      if (!r2) return;
      var s2 = r2.querySelector('strong'), t2 = money(td);
      if (s2.textContent !== t2) s2.textContent = t2;
      if (r2.classList.contains('d-none') !== !(td > 0)) r2.classList.toggle('d-none', !(td > 0));
      if (r2.nextElementSibling !== sub2) sub2.parentNode.insertBefore(r2, sub2);
      var b2 = document.getElementById('bonus-savings-drawer');
      if (b2 && b2.nextElementSibling !== r2) sub2.parentNode.insertBefore(b2, r2);
    }).catch(function () {});
  }
  var tm; function later() { clearTimeout(tm); tm = setTimeout(apply, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  window.addEventListener('updated.ecomify.cart', later);                  // téma po zmene košíka prekreslí telo aj pätu lišty
  document.addEventListener('shown.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') later(); });
  var w = document.getElementById('offcanvas-cart-wrapper');
  if (w) new MutationObserver(later).observe(w, { childList: true, subtree: true });
})();
/* == /bonusy == */

/* == cenovka po prepnutí variantu (The GARDEN, 8. 10. 2026) ==
   assets/product.js skladá cenu ako Shopify.formatMoney(x) + ' ' + Shopify.currency.active,
   takže po prepnutí variantu napíše "89,00 EUR" namiesto "89,00 €".
   Shopify.currency.active neprepisujeme, číta ho Zipify pri analytike (zp_page_viewed).
   Opravujeme len text vo vnútri cenovky. */
;(function () {
  if (window.__egMenaInit) return;                                         // snippet sa na PDP vykresľuje aj druhýkrát
  window.__egMenaInit = true;
  var KOD = /\s*\bEUR\b/g, ZNAK = ' €';
  function oprav(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, v;
    while ((n = w.nextNode())) {
      if (n.nodeValue.indexOf('EUR') === -1) continue;
      v = n.nodeValue.replace(KOD, ZNAK);
      if (v !== n.nodeValue) n.nodeValue = v;                              // zapisujeme len pri zmene, inak by observer cyklil
    }
  }
  function odznak(el) {                                                    // téma ráta zľavu aj keď je prečiarknutá cena <= predajnej -> "zlava: -8%" alebo "zlava: 0%"
    el.querySelectorAll('.price-badge-sale').forEach(function (b) {        // server taký odznak nikdy nevykreslí, zosúlaďujeme JS so serverom
      var m = (b.textContent || '').match(/(-?\d+)\s*%/);
      if (m && Number(m[1]) <= 0) b.remove();
    });
  }
  var caka = false;
  function neskor() {
    if (caka) return;
    caka = true;
    setTimeout(function () {                                               // nie requestAnimationFrame: v skrytej karte sa nespusti
      caka = false;
      document.querySelectorAll('.product-price').forEach(function (el) { oprav(el); odznak(el); });
    }, 0);
  }
  function start() {
    var ceny = document.querySelectorAll('.product-price');
    if (!ceny.length) return;
    var obs = new MutationObserver(neskor);
    ceny.forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true, characterData: true });
      oprav(el);
      odznak(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
/* == /cenovka == */
